__turbopack_context__.v({
  "section": "eHsoxW_section",
  "tile": "eHsoxW_tile",
  "tilePicture": "eHsoxW_tilePicture",
  "tileSide": "eHsoxW_tileSide",
  "tiles": "eHsoxW_tiles",
  "title": "eHsoxW_title",
});
